import PropTypes from 'prop-types'
import React, { Component } from 'react'
import classnames from 'classnames'

import Icon from './Icon'

import { focusNextElement } from '../../utils/dom'

class Input extends Component {
  constructor (props) {
    super()
    this._handlePaste = this._handlePaste.bind(this)
    this._handleBlur = this._handleBlur.bind(this)
    this._handleClick = this._handleClick.bind(this)
    this._handleKeyPress = this._handleKeyPress.bind(this)
    this._handleChange = this._handleChange.bind(this)
  }
  componentDidMount () {
    if (this.props.autoFocus && this.element) {
      this.element.focus()
    }
  }
  _handlePaste (e) {
    const { maxLength } = this.props
    const clipboardData = e.clipboardData || window.clipboardData
    const pastedData = clipboardData ? clipboardData.getData('text') : ''

    // NOTE: current selection for some reason does not return the real selection in firefox,
    // possibly because this is an input/textarea, or because the paste replacement has already happened.
    // In either case, it's not critical for that to work - it only makes it so
    // our check for exceeding max length doesn't falsely trigger when the user intents to
    // paste replace text (into the selection)
    const currentSelectionLength = window.getSelection().toString().length
    const updatedTextLength =
      this.element.textContent.length -
      currentSelectionLength +
      pastedData.length
    if (updatedTextLength > maxLength) {
      e.preventDefault()
    }
  }
  _handleBlur (e) {
    const { onBlur } = this.props
    onBlur && onBlur(e, e.target.value)
  }
  _handleClick (e) {
    e.preventDefault()
    e.nativeEvent.stopImmediatePropagation() // Prevent click bubbling
    e.stopPropagation()
  }
  _handleChange (e) {
    this.props.onChange && this.props.onChange(e.target.value, e)
  }
  _handleKeyPress (e) {
    const {
      maxLength,
      blurOnEnter,
      focusNextElementOnEnter,
      Element,
      onEnter
    } = this.props

    if (e.charCode === 13 && Element !== 'textarea') {
      // Enter
      e.preventDefault()
      onEnter && onEnter(e, e.target.value)
      if (focusNextElementOnEnter) {
        focusNextElement()
      } else if (blurOnEnter) {
        e.target && e.target.blur()
      }
    } else if (
      maxLength &&
      e.target.value.length > maxLength
      // do we need to not block certain keys,
      // like left arrow, backspace, delete?
      // Seems like they dont fire for keyPress event..
    ) {
      e.preventDefault()
    }
  }
  render () {
    const {
      Element,
      disabled,
      readOnly,
      required,
      pattern,
      defaultValue,
      maxLength,
      placeholder,
      title,
      extraClass,
      containerExtraClass,
      iconExtraClass,
      type,
      name,
      rows,
      value,
      icon,
      rightContent
    } = this.props

    const element = (
      <Element
        className={classnames('input', extraClass)}
        defaultValue={defaultValue}
        value={value}
        placeholder={placeholder}
        title={title}
        disabled={disabled}
        readOnly={readOnly}
        required={required}
        pattern={pattern}
        type={type}
        name={name}
        rows={Element === 'textarea' ? rows : undefined}
        ref={el => {
          this.element = el
        }}
        onBlur={this._handleBlur}
        onPaste={maxLength && this._handlePaste}
        onKeyPress={this._handleKeyPress}
        onClick={this._handleClick}
        onChange={this._handleChange}
      />
    )

    const inputContent = (
      <div className='input-container flex items-center'>
        {icon && (
          <Icon
            icon={icon}
            className={classnames('icon absolute', iconExtraClass)}
          />
        )}
        {element}
        {rightContent && (
          <div className='input-container__right-content icon absolute'>
            {rightContent}
          </div>
        )}
      </div>
    )
    return <div className={containerExtraClass}>{inputContent}</div>
  }
}

Input.propTypes = {
  Element: PropTypes.string,
  autoFocus: PropTypes.bool,
  defaultValue: PropTypes.string,
  value: PropTypes.string,
  maxLength: PropTypes.number,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  readOnly: PropTypes.bool,
  required: PropTypes.bool,
  pattern: PropTypes.string,
  // disabled for textareas
  focusNextElementOnEnter: PropTypes.bool,
  // focusNextElementOnEnter takes priority over blurOnEnter
  blurOnEnter: PropTypes.bool,
  name: PropTypes.string,
  rows: PropTypes.number, // for textareas
  onBlur: PropTypes.func,
  onEnter: PropTypes.func,
  onChange: PropTypes.func,
  icon: PropTypes.string,
  extraClass: PropTypes.string,
  containerExtraClass: PropTypes.string,
  iconExtraClass: PropTypes.string,
  rightContent: PropTypes.object
}

Input.defaultProps = {
  Element: 'input',
  type: 'text',
  blurOnEnter: true,
  // set rows only for textareas
  rows: 3
}

export default Input



// WEBPACK FOOTER //
// ./frontend/scripts/react/components/Input.js